import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConstants } from '../../common/common';
import { map, catchError } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';
@Injectable({
  providedIn: 'root'
})
export class SeverancePayConfigurationService {

  constructor(public http: HttpClient) { }


  public GetSeverancePayConfigInitialData() {
    return this.http.get(AppConstants.BasePath + 'GetSeverancePayConfigInitialData').pipe(
      map(this.SuccessHandler), catchError(this.ErrorHandler)); 

  }


  public LoadSeverancePayConfig() {
    return this.http.get(AppConstants.BasePath + 'LoadSeverancePayConfig').pipe(
      map(this.SuccessHandler), catchError(this.ErrorHandler));

  }
  
  public CreateNewSeverancePayConfig() {
    return this.http.get(AppConstants.BasePath + 'CreateNewSeverancePayConfig').pipe(
      map(this.SuccessHandler), catchError(this.ErrorHandler));

  }

  


  public SaveSeverancePayConfig(data: any): any {
    return this.http.post(AppConstants.BasePath + 'SaveSeverancePayConfig', data).pipe(
      map(this.SuccessHandler), catchError(this.ErrorHandler));
  }


  public DeleteSeverancePayConfig(data: any): any {
    return this.http.post(AppConstants.BasePath + 'DeleteSeverancePayConfig', data).pipe(
      map(this.SuccessHandler), catchError(this.ErrorHandler));
  }


  
  

  

  
  public SaveLeaveApprovalHierarchy(data: any): any {
    return this.http.post(AppConstants.BasePath + 'SaveLeaveApprovalHierarchy', data).pipe(
      map(this.SuccessHandler), catchError(this.ErrorHandler));
  }
  

  
  OpenSeverancePayConfig(data: any): any {
    return this.http.post(AppConstants.BasePath + 'OpenSeverancePayConfig',data).pipe(
      map(this.SuccessHandler),catchError(this.ErrorHandler));
  }

  private SuccessHandler(responce: Response) {
    let data = responce;
    return data || {};
  }
  private ErrorHandler(error: Response | any) {
    let errorMSg: string;
    if (error instanceof Response) {
      const err = error || '';
      errorMSg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errorMSg = error.message ? error.message : error.toString();
    }
    return _throw(error);
  }
}
